export const ActionTypes = {
  // user
  USER_REGISTER_PENDING: "USER_REGISTER_PENDING",
  USER_LOGIN_PENDING: "USER_LOGIN_PENDING",
  USER_REGISTER_SUCCESS: "USER_REGISTER_SUCCESS",
  USER_LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  UPDATE_USER: "UPDATE_USER",
  BOOKING: "BOOKING",
  DETAIL: "DETAIL",
  CREATE_BOOKINGS: "CREATE_BOOKINGS",
  GET_BOOKING_ERROR: "GET_BOOKING_ERROR",

  CREATE_AIRLANES: "CREATE_AIRLANES",
  GET_AIRLANES_ERROR: "GET_AIRLANES_ERROR",
};


